export const PROFILE_NOTIFICATION_MODULE_NAMESPACE = 'profileNotification';
export const PROFILE_NOTIFICATION_LOADING = 'PROFILE_NOTIFICATION_LOADING';
export const PROFILE_NOTIFICATION = 'PROFILE_NOTIFICATION';
export const PROFILE_SET_NOTIFICATION = 'PROFILE_SET_NOTIFICATION';
export const PROFILE_SET_NOTIFICATION_ROWS = 'PROFILE_SET_NOTIFICATION_ROWS';
export const REVERT_PROFILE_NOTIFICATION = 'REVERT_PROFILE_NOTIFICATION';
export const PROFILE_SET_NOTIFICATION_PATCH = 'PROFILE_SET_NOTIFICATION_PATCH';
export const PROFILE_PATCH_NOTIFICATION = 'PROFILE_PATCH_NOTIFICATION';
export const PROFILE_NOTIFICATION_SET_LOADER_STATE = 'PROFILE_NOTIFICATION_SET_LOADER_STATE'
export const PROFILE_NOTIFICATION_LOADERS= Object.freeze({
    NOTIFICATIONS_DETAILS: 'PROFILE_NOTIFICATION_DETAILS',
    NOTIFICATIONS_SIDEBAR: 'PROFILE_NOTIFICATIONS_SIDEBAR'
})



// WEBPACK FOOTER //
// ./src/store/profile-notification/profile-notification-types.store.ts